// Shared display semantics for private lesson slot statuses. A slot's status is
// the coach's event_booking status: 'pending' means the slot is open for
// booking, and 'invited' means wrestlers booked it and the coach still needs to
// confirm (parents see this as "Coach needs to confirm" — never say "Invited"
// for a coach booking, it reads backwards on the coach's own dashboard).
export const privateLessonStatusMix = {
  methods: {
    slotStatusLabel(status) {
      switch (status) {
        case 'pending': return 'Open';
        case 'confirmed': return 'Booked';
        case 'cancelled': return 'Cancelled';
        case 'completed': return 'Completed';
        case 'invited': return 'Needs confirmation';
        case 'declined': return 'Declined';
        default: return 'Open';
      }
    },
    // Per-person label for participant rows (event detail page): a person is
    // 'Confirmed'; only the slot itself reads 'Booked' on schedule views
    participantStatusLabel(status) {
      if (status === 'confirmed') {
        return 'Confirmed';
      }
      return this.slotStatusLabel(status);
    },
    // Wrestler bookings keep 'Invited' — there it really does mean the family
    // was invited to the lesson and hasn't accepted yet
    wrestlerStatusLabel(status) {
      if (status === 'invited') {
        return 'Invited';
      }
      return this.participantStatusLabel(status);
    },
    // Badge color classes from the internal utility palette
    slotStatusBadgeClass(status) {
      switch (status) {
        case 'pending': return 'bg-green-50 text-green-700';
        case 'confirmed': return 'bg-blue-50 text-blue-700';
        case 'cancelled': return 'bg-red-50 text-red-700';
        case 'completed': return 'bg-gray-100 text-gray-600';
        case 'invited': return 'bg-yellow-50 text-yellow-700';
        case 'declined': return 'bg-red-50 text-red-700';
        default: return 'bg-green-50 text-green-700';
      }
    },
  },
};
